module.exports = __webpack_public_path__ + "img/redlining.2c234c38.png";